
<style lang='less' scoped>
/deep/.amap-geolocation-con{bottom: 50px !important;}
</style>

<template >
  <div>
  </div>
</template>

<script>
import AMap from 'AMap'
let map, marker, infoWindow
export default {
  data()
  {
    return {
      arriveCoor: [116.481181, 39.989792], //坐标点
      arrive: ''//位置信息
    }
  },
  mounted()
  {
    this.mapDraw(this.arriveCoor)
    this.$nextTick(() =>
    {
      this.setInitSty()
    })
  },
  methods: {
    mapDraw(arriveCoor)
    {
      map = new AMap.Map('map2D', {   //map-location是嵌地图div的id
        resizeEnable: true, //是否监控地图容器尺寸变化
        zoom: 5, //初始化地图层级
        center: arriveCoor //初始化地图中心点
      })
      AMap.plugin([
        'AMap.ToolBar',
        'AMap.Scale',
        'AMap.OverView',
        'AMap.MapType',
        'AMap.Geolocation'
      ], function()
      {
        // 在图面添加工具条控件，工具条控件集成了缩放、平移、定位等功能按钮在内的组合控件
        map.addControl(new AMap.ToolBar())
        var scale = new AMap.Scale(
          {
            position: 'RB'
          })
        // 在图面添加比例尺控件，展示地图在当前层级和纬度下的比例尺
        map.addControl(scale)
        // 在图面添加类别切换控件，实现默认图层与卫星图、实施交通图层之间切换的控制
        map.addControl(new AMap.MapType())
        // 在图面添加定位控件，用来获取和展示用户主机所在的经纬度位置
        map.addControl(new AMap.Geolocation())
      })
      // 定位点
      this.addMarker(arriveCoor)
    },
    // 实例化点标记
    addMarker(arriveCoor)
    {
      marker = new AMap.Marker({
        icon: '',  //图片ip
        imageSize: '20px',
        position: arriveCoor,
        offset: new AMap.Pixel(-13, -30),
        // 设置是否可以拖拽
        draggable: false,
        cursor: 'move',
        // 设置拖拽效果
        raiseOnDrag: true
      })
      //将创建的点添加到地图实例中
      marker.setMap(map)
      AMap.event.addListener(marker, 'click', function()
      {
        infoWindow.open(map, marker.getPosition())
      })
      //在指定位置打开信息窗体
      //构建信息窗体中显示的内容
      var info = []
      // info.push("<img src='http://tpc.googlesyndication.com/simgad/5843493769827749134' class='mappho'>")
      info.push(`<div style='width:320px'><img src='http://tpc.googlesyndication.com/simgad/5843493769827749134' class='mappho'><p class='input-item'>地址 :北京市朝阳区望京阜荣街10号首开广场4层</p></div>`)
      infoWindow = new AMap.InfoWindow({
        isCustom: true, //使用自定义窗口
        content: info.join(''),  //使用默认信息窗体框样式，显示信息内容
        offset: new AMap.Pixel(0, -25)
      })
    },
    setInitSty()
    {
      let start = setInterval(() =>
      {
        let title = document.querySelector('.input-item')
        let mappho = document.querySelector('.mappho')
        let box = document.querySelector('.box')
        if (title && mappho && box)
        {
          box.style.width = '320px'
          mappho.style.width = '200px'
          mappho.style.userSelect = 'none'
          mappho.style.verticalAlign = 'middle'
          title.style.width = '200px'
          title.style.margin = 'auto'
          title.style.textAlign = 'left'
          title.style.userSelect = 'none'
          title.style.background = '#fff'
          clearInterval(start)
        }
      }, 50)
    },
    //关闭信息窗体
    closeInfoWindow()
    {
      map.clearInfoWindow()
    }
  }
}

</script>




// WEBPACK FOOTER //
// src/plugins/app/method/loadmap.vue